/**
 * Truncates text to a specified length
 * @param {string} text - The text to truncate
 * @param {number} maxLength - Maximum length before truncation
 * @returns {string} - Truncated text
 */
export const truncateText = (text, maxLength) => {
  // Return empty string if text is null or undefined
  if (!text) return '';
  
  // Convert to string in case it's a number or other type
  const textStr = String(text);
  
  // If text is shorter than maxLength, return it as is
  if (textStr.length <= maxLength) return textStr;
  
  // Otherwise, truncate and return
  return textStr.substring(0, maxLength);
};

// Add any other text-related helper functions here